import PropTypes from 'prop-types';
import { clone, includes, reject } from 'ramda';
import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

/**
 * ServicedRailwaysField is a stateless functional component for redux-form
 * forms, where the value is a list of Railway identifiers. Railways can be
 * selected and deselected, and the redux-form state is updated immediately.
 */
const ServicedRailwaysField = ({
  input: { onChange, value },
  meta: { touched, error, warning },
  railways,
}) => (
  <Card>
    {touched && (error || warning) && (
      <CardHeader title={error || warning} />
    )}

    <CardContent>
      <Table>
        <TableBody>
          {railways.map((railway) => (
            <TableRow
              key={`railway-${railway.id}`}
              selected={includes(railway.id, value)}
              padding="checkbox"
              onClick={() => {
                let _value = clone(value || []);

                if (_value.includes(railway.id)) {
                  _value = reject(v => v === railway.id, _value);
                } else {
                  _value.push(railway.id);
                }

                onChange(_value);
              }}
            >
              <TableCell padding="checkbox">
                <Checkbox checked={includes(railway.id, value)} color="primary" />
              </TableCell>

              <TableCell>{railway.attributes.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

ServicedRailwaysField.propTypes = {
  // redux-form props
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,

  // own props
  railways: PropTypes.arrayOf(PropTypes.shape({
    attributes: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    id: PropTypes.string.isRequired,
  })).isRequired,
};

ServicedRailwaysField.defaultProps = {
  input: {
    value: [],
  },
  meta: {
    error: undefined,
    warning: undefined,
  },
};

export default ServicedRailwaysField;
